import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { inviteFriends } from '../../SocialPage/social.slice';
import { ALERT_BARS_HANDLE } from '../../../../redux/interfaces/types';

const InviteFriendsModal = ({ show, onHide, uuid }) => {
    const [friendInput, setFriendInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const handleClose = () => {
        setFriendInput('');
        setIsLoading(false);
        onHide();
    };

    const handleSubmit = async () => {
        if (!friendInput.trim()) {
            dispatch({
                type: ALERT_BARS_HANDLE,
                message_type: "warning",
                message: "Please enter at least one friend handle or email"
            });
            return;
        }

        setIsLoading(true);

        // Split the input by commas and trim whitespace
        const friends = friendInput.split(',').map(friend => friend.trim()).filter(friend => friend.length > 0);

        if (friends.length === 0) {
            dispatch({
                type: ALERT_BARS_HANDLE,
                message_type: "warning",
                message: "Please enter valid friend handles or emails"
            });
            setIsLoading(false);
            return;
        }

        try {
            // Join all friends with commas for the API call
            const emailsString = friends.join(',');

            const response = await dispatch(inviteFriends({
                uuid: uuid,
                emails: emailsString
            })).unwrap();

            const success = response?.status === "success";
            if (success) {
                setFriendInput('');
                handleClose();
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Error sending friend invites:', error);
            setIsLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            size="md"
            style={{ zIndex: 9999 }}
        >
            <Modal.Body style={{ padding: '30px', backgroundColor: 'white' }}>
                <div style={{
                    fontFamily: 'Futura LT BT, sans-serif',
                    fontSize: '16px',
                    fontWeight: '500',
                    color: '#000',
                    marginBottom: '20px',
                    lineHeight: '1.4'
                }}>
                    Enter your friends @müvhandle or email,
                    all separated by commas
                </div>

                <Form.Group>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        value={friendInput}
                        onChange={(e) => setFriendInput(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder="enter handles and/or emails here"
                        style={{
                            border: '2px dashed #ccc',
                            borderRadius: '8px',
                            padding: '15px',
                            fontSize: '14px',
                            fontFamily: 'Futura LT BT, sans-serif',
                            color: '#666',
                            resize: 'none',
                            outline: 'none',
                            boxShadow: 'none',
                            borderColor: friendInput ? '#19BC9B' : '#ccc',
                            transition: 'border-color 0.3s ease'
                        }}
                    />
                </Form.Group>

                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '20px',
                    marginBottom: '15px'
                }}>
                    <Button
                        onClick={handleSubmit}
                        disabled={isLoading || !friendInput.trim()}
                        style={{
                            backgroundColor: '#19BC9B',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontFamily: 'Futura LT BT, sans-serif',
                            fontWeight: '500',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: 'none',
                            opacity: isLoading || !friendInput.trim() ? 0.6 : 1,
                            cursor: isLoading || !friendInput.trim() ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {isLoading ? 'Sending...' : 'Next Step'}
                        {!isLoading && (
                            <span style={{ fontSize: '16px' }}>→</span>
                        )}
                    </Button>
                </div>

                <div style={{
                    fontSize: '12px',
                    fontFamily: 'Futura LT BT, sans-serif',
                    color: '#000',
                    lineHeight: '1.3',
                    marginTop: '10px'
                }}>
                    You can upload any number of friends at the same time, just make sure to separate them with a comma
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default InviteFriendsModal;
